import { forwardRef } from 'react';
import type { JavascriptHookCustomAction, JavascriptHookType } from 'autogen/swagger/all';
import useOpenRevievePlugin from 'components/Revieve/shared/initializeRevieveScript';
import { CustomActionButton } from '../../shared/styles';
import type { CustomActionProps, RevieveActionTypes } from '../../shared/types';

type CustomerServiceActionProps = {
    action: Omit<JavascriptHookCustomAction, 'javascriptHookType'> & {
        javascriptHookType: RevieveActionTypes;
    };
} & CustomActionProps;

const RevieveAction = forwardRef<HTMLButtonElement, CustomerServiceActionProps>(
    ({ action, onClick, ...restProps }, ref) => {
        const openRevieve = useOpenRevievePlugin();

        return (
            <CustomActionButton
                ref={ref}
                type="button"
                onClick={async (event) => {
                    await openRevieve({ type: action.javascriptHookType });
                    onClick?.(event);
                }}
                {...restProps}
            />
        );
    }
);

export default RevieveAction;
